import React, { useEffect, useState } from "react";
import {
  Button,
  Center,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text
} from "@chakra-ui/react";
import { useLazySearchLogQuery } from "../api";
import dayjs from "dayjs";
import { PageCardComponent } from "modules/core/components/page-card.component";
import { Log, Person, PoliceCase, User, Patient } from "app/api/type";
import { LogComponent } from "./log.component";

interface Props {
  userId?: string;
}

export const UserLogTableComponent: React.FC<Props> = (props: Props) => {
  const [searchLogs, searchLogsResult] = useLazySearchLogQuery();

  const loggedInUserId = window.localStorage.getItem("id") as string;

  const [isDefault, setIsDefault] = useState<boolean>(false);
  const [logs, setLogs] = useState<
    {
      log: Log;
      userWithDetails: {
        user: Omit<User, "password">;
        person: Person;
      };
      patientWithDetails: {
        patient: Patient;
        person: Person;
      } | null;
      policeCase: PoliceCase | null;
    }[]
  >([]);

  const [userId, setUserId] = useState<string>(loggedInUserId);

  useEffect(() => {
    if (props.userId) {
      if (props.userId === "default") {
        setIsDefault(true);
      } else {
        setIsDefault(false);
        searchLogs({ searchBy: "user", searchValue: props.userId });
      }
    }
  }, []);

  useEffect(() => {
    if (searchLogsResult.isSuccess) {
      setLogs(searchLogsResult.data.logsWithDetails);
    }
  }, [searchLogsResult]);

  const handleSearch = () => {
    if (isDefault && userId) {
      searchLogs({ searchBy: "user", searchValue: userId });
    }
  };

  return (
    <Stack spacing="4">
      {isDefault ? (
        <PageCardComponent>
          <FormControl>
            <FormLabel>User ID</FormLabel>
            <Stack direction="row">
              <Input
                value={userId}
                onChange={(event) => {
                  setUserId(event.target.value);
                }}
              />
              <Button
                onClick={handleSearch}
                isLoading={searchLogsResult.isLoading}
                isDisabled={!userId}
              >
                Search
              </Button>
            </Stack>
          </FormControl>
        </PageCardComponent>
      ) : (
        <Heading fontSize="2xl" color="gray.500">
          ID {props.userId}
        </Heading>
      )}

      {logs.map((log) => {
        return <LogComponent logWithDetails={log} />;
      })}
      {logs.length === 0 ? (
        <Center width="100%" height="128px">
          <Text color="gray.500">No logs found</Text>
        </Center>
      ) : (
        <></>
      )}
    </Stack>
  );
};
